import "./repo.a5e9c946.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecaa2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecaa2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lsboS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9e50e5a44fb11e0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ArrowRight", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
]);

});

parcelRegister("gn8IX", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb58fc2118025b6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $beb58fc2118025b6$export$2e2bcd8739ae039 = (0, $b4WUK.default)("CalendarDays", [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M8 18h.01",
            key: "lrp35t"
        }
    ],
    [
        "path",
        {
            d: "M12 18h.01",
            key: "mhygvu"
        }
    ],
    [
        "path",
        {
            d: "M16 18h.01",
            key: "kzsmim"
        }
    ]
]);

});

parcelRegister("ki04U", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec558c98a508af21$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $ec558c98a508af21$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Clock3", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16.5 12",
            key: "1aq6pp"
        }
    ]
]);

});

parcelRegister("ced6i", function(module, exports) {

$parcel$export(module.exports, "EventCover", () => $e5ba17c63bc0e4da$export$10ca8b5adb16b591);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c91it = parcelRequire("c91it");
function $e5ba17c63bc0e4da$export$10ca8b5adb16b591({ src: src, className: className = '', fallback: fallback, children: children, onAvailability: onAvailability }) {
    const sources = src ? (0, $c91it.expandImageSources)(src) : [];
    const [index, setIndex] = (0, $acw62.useState)(0);
    const current = sources[index];
    if (!current) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `${className} is-fallback`,
        children: [
            fallback,
            children
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: current,
                alt: "",
                loading: "lazy",
                onLoad: ()=>onAvailability?.(true),
                onError: ()=>{
                    const next = index + 1;
                    if (next >= sources.length) onAvailability?.(false);
                    setIndex(next);
                }
            }),
            children
        ]
    });
}

});

parcelRegister("dSNXT", function(module, exports) {

$parcel$export(module.exports, "RecurrenceBadge", () => $760f5631e1d6e874$export$bf031ef5546a1292);
$parcel$export(module.exports, "RegistrationBadge", () => $760f5631e1d6e874$export$6aa4bebb1f9a7d61);
$parcel$export(module.exports, "EventPeople", () => $760f5631e1d6e874$export$dc2c6f01e73f82f);

var $ayMG0 = parcelRequire("ayMG0");

var $4JXUu = parcelRequire("4JXUu");
var $9eJBK = parcelRequire("9eJBK");

var $c91it = parcelRequire("c91it");
function $760f5631e1d6e874$export$bf031ef5546a1292({ event: event }) {
    if (!event.recurring) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "event-recurrence-badge",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9eJBK.default), {
                size: 14,
                "aria-hidden": "true"
            }),
            "Recurrente",
            event.recurrenceLabel ? ` \xb7 ${event.recurrenceLabel}` : ''
        ]
    });
}
function $760f5631e1d6e874$export$6aa4bebb1f9a7d61({ event: event }) {
    if (!event.registrationUrl) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "event-register-badge",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4JXUu.default), {
                size: 14,
                "aria-hidden": "true"
            }),
            "Requiere inscripci\xf3n"
        ]
    });
}
function $760f5631e1d6e874$var$PeopleGroup({ names: names, label: label, variant: variant }) {
    if (!names.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `event-people-group is-${variant}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                children: label
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                children: names.map((name)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true",
                                children: (0, $c91it.personInitials)(name)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: name
                            })
                        ]
                    }, `${variant}-${name}`))
            })
        ]
    });
}
function $760f5631e1d6e874$export$dc2c6f01e73f82f({ event: event }) {
    if (!event.organizers.length && !event.guests.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "event-people",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($760f5631e1d6e874$var$PeopleGroup, {
                names: event.organizers,
                label: event.organizers.length > 1 ? 'Organizan' : 'Organiza',
                variant: "organizer"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($760f5631e1d6e874$var$PeopleGroup, {
                names: event.guests,
                label: event.guests.length > 1 ? 'Invitados' : 'Invitado',
                variant: "guest"
            })
        ]
    });
}

});
parcelRegister("4JXUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3739d64fb7ddfae6$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $3739d64fb7ddfae6$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ClipboardList", [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            key: "116196"
        }
    ],
    [
        "path",
        {
            d: "M12 11h4",
            key: "1jrz19"
        }
    ],
    [
        "path",
        {
            d: "M12 16h4",
            key: "n85exb"
        }
    ],
    [
        "path",
        {
            d: "M8 11h.01",
            key: "1dfujw"
        }
    ],
    [
        "path",
        {
            d: "M8 16h.01",
            key: "18s6g9"
        }
    ]
]);

});

parcelRegister("9eJBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b98cc9f5dadc552$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $6b98cc9f5dadc552$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Repeat", [
    [
        "path",
        {
            d: "m17 2 4 4-4 4",
            key: "nntrym"
        }
    ],
    [
        "path",
        {
            d: "M3 11v-1a4 4 0 0 1 4-4h14",
            key: "84bu3i"
        }
    ],
    [
        "path",
        {
            d: "m7 22-4-4 4-4",
            key: "1wqhfi"
        }
    ],
    [
        "path",
        {
            d: "M21 13v1a4 4 0 0 1-4 4H3",
            key: "1rx37r"
        }
    ]
]);

});


parcelRegister("gRgf3", function(module, exports) {

$parcel$export(module.exports, "PageHero", () => $5405cac3ced8ac70$export$4b2976b57d220ac6);

var $ayMG0 = parcelRequire("ayMG0");
function $5405cac3ced8ac70$export$4b2976b57d220ac6({ kicker: kicker, title: title, lead: lead, image: image, imageAlt: imageAlt = '', children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "page-hero",
        children: [
            image && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-hero-media",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: image,
                        alt: imageAlt
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "page-hero-overlay"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-shell page-hero-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "eyebrow eyebrow-light reveal is-visible",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true"
                            }),
                            " ",
                            kicker
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "reveal is-visible",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "page-hero-lead reveal is-visible",
                        children: lead
                    }),
                    children && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "page-hero-extra reveal is-visible",
                        children: children
                    })
                ]
            })
        ]
    });
}

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $lsboS = parcelRequire("lsboS");
var $gn8IX = parcelRequire("gn8IX");

var $ayMG0 = parcelRequire("ayMG0");

var $lsboS = parcelRequire("lsboS");
var $ki04U = parcelRequire("ki04U");
var $hipFw = parcelRequire("hipFw");

var $ced6i = parcelRequire("ced6i");

var $dSNXT = parcelRequire("dSNXT");

var $c91it = parcelRequire("c91it");
function $36da971f4939abf4$export$17d6e9b478c1493c({ event: event }) {
    const date = (0, $c91it.formatEventCardDate)(event);
    const cover = event.images[0];
    const href = (0, $c91it.eventDetailHref)(event);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
        className: "event-card reveal",
        href: href,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ced6i.EventCover), {
                src: cover,
                className: "event-card-media",
                fallback: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "event-card-fallback",
                    "aria-hidden": "true",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                            children: date.day
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: date.month
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("time", {
                    className: "event-date-badge",
                    dateTime: event.start.toISOString(),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                            children: date.day
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: date.month
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "event-card-body",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "event-card-topline",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "event-card-meta",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ki04U.default), {
                                            size: 15,
                                            "aria-hidden": "true"
                                        }),
                                        " ",
                                        date.weekday,
                                        " \xb7 ",
                                        date.time
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dSNXT.RecurrenceBadge), {
                                event: event
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dSNXT.RegistrationBadge), {
                                event: event
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: event.title
                    }),
                    event.excerpt && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: event.excerpt
                    }),
                    event.location && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "event-card-location",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hipFw.default), {
                                size: 15,
                                "aria-hidden": "true"
                            }),
                            " ",
                            event.location
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "event-card-action",
                        children: [
                            "Ver evento ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsboS.default), {
                                size: 16,
                                "aria-hidden": "true"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $5xqgC = parcelRequire("5xqgC");

var $gRgf3 = parcelRequire("gRgf3");

var $clpju = parcelRequire("clpju");

var $3ua1s = parcelRequire("3ua1s");
function $8e7fcaeb41ef9d96$export$88e9adbf5a80d086() {
    const { events: events, status: status } = (0, $3ua1s.useEvents)();
    (0, $3ua1s.useReveal)(status);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5xqgC.Layout), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gRgf3.PageHero), {
                kicker: "Eventos",
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Lo que Dios est\xe1 ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                            children: "haciendo"
                        }),
                        " en la casa."
                    ]
                }),
                lead: "Retiros, noches especiales, alcance y celebraciones. Revisa fechas y detalles \u2014 todo en horario de Ciudad Ju\xe1rez.",
                image: (0, $clpju.imgCongregacionWide),
                imageAlt: "Congregaci\xf3n de Tercer Cielo reunida en un encuentro",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                    className: "button button-gold",
                    href: "#eventos-lista",
                    children: [
                        "Ver pr\xf3ximos eventos ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsboS.default), {
                            size: 18,
                            "aria-hidden": "true"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "section-space events-list-section",
                id: "eventos-lista",
                "aria-labelledby": "eventos-lista-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "section-heading reveal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "section-kicker",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                                " Agenda"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            id: "eventos-lista-title",
                                            children: "Pr\xf3ximos encuentros."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Horarios en Ciudad Ju\xe1rez, Chihuahua. Elige un evento para ver todos los detalles."
                                })
                            ]
                        }),
                        status === 'loading' && /*#__PURE__*/ (0, $ayMG0.jsx)($8e7fcaeb41ef9d96$var$EventsStatusBox, {
                            children: "Cargando la agenda\u2026"
                        }),
                        status === 'error' && /*#__PURE__*/ (0, $ayMG0.jsx)($8e7fcaeb41ef9d96$var$EventsStatusBox, {
                            children: "No pudimos cargar los eventos en este momento. Intenta de nuevo en unos minutos."
                        }),
                        status === 'ready' && events.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($8e7fcaeb41ef9d96$var$EventsStatusBox, {
                            children: "Pronto anunciaremos nuevos eventos. Mientras tanto, te esperamos en nuestros servicios semanales."
                        }),
                        status === 'ready' && events.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "events-grid",
                            children: events.map((event)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $36da971f4939abf4$export$17d6e9b478c1493c), {
                                    event: event
                                }, `${event.uid}-${event.start.toISOString()}`))
                        })
                    ]
                })
            })
        ]
    });
}
function $8e7fcaeb41ef9d96$var$EventsStatusBox({ children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "events-empty reveal",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gn8IX.default), {
                size: 28,
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: children
            })
        ]
    });
}



const $7891ba9a923a1e49$var$container = document.getElementById('app');
(0, $aRPiL.createRoot)($7891ba9a923a1e49$var$container).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8e7fcaeb41ef9d96$export$88e9adbf5a80d086), {})
}));


//# sourceMappingURL=eventos.a930a1b4.js.map
